// src/pages/PaymentSuccess.js
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';

const PaymentSuccess = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const orderId = query.get('orderId');
  const refId = query.get('refId') || 'TEST-' + Date.now();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await axios.get(`/orders/${orderId}`);
        setOrder(res.data);
      } catch (error) {
        console.error('خطا در دریافت فاکتور:', error);
      } finally {
        setLoading(false);
      }
    };

    if (orderId) fetchOrder();
  }, [orderId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-2xl text-gold-dark">در حال بارگذاری فاکتور...</div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-red-50">
        <div className="text-center">
          <p className="text-2xl text-red-600 mb-6">فاکتور یافت نشد</p>
          <Link to="/cart" className="bg-gold text-white px-8 py-4 rounded-xl">بازگشت به سبد خرید</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* هدر موفقیت */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white py-12 text-center">
            <div className="text-6xl mb-4">✓</div>
            <h1 className="text-4xl font-bold">پرداخت پیش‌پرداخت با موفقیت انجام شد!</h1>
            <p className="text-xl mt-4">شماره پیگیری: <span className="font-mono text-2xl">{refId}</span></p>
          </div>

          <div className="p-10">
            <div className="text-center mb-10">
              <p className="text-2xl text-gray-800 font-bold">فاکتور شماره {order.order_number}</p>
              <p className="text-lg text-gray-600 mt-2">تاریخ: {new Date().toLocaleDateString('fa-IR')}</p>
            </div>

            {/* خلاصه مالی */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-green-50 rounded-2xl p-8 text-center">
                <p className="text-gray-700 text-lg">مبلغ پرداخت‌شده (پیش‌پرداخت)</p>
                <p className="text-4xl font-bold text-green-700 mt-4">
                  {Number(order.total_pre_payment).toLocaleString('fa-IR')} تومان
                </p>
              </div>

              <div className="bg-purple-50 rounded-2xl p-8 text-center">
                <p className="text-gray-700 text-lg">بدهی باقی‌مانده (به گرم طلا)</p>
                <p className="text-4xl font-bold text-purple-900 mt-4">
                  {Number(order.total_gold_debt).toFixed(3)} گرم
                </p>
              </div>
            </div>

            {/* لیست محصولات */}
            <div className="mb-12">
              <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">محصولات خریداری‌شده</h3>
              <div className="space-y-6">
                {order.items.map(item => (
                  <div key={item.id} className="bg-gray-50 rounded-xl p-6 flex items-center gap-6">
                    <img
                      src={item.images?.[0]?.image_url || '/placeholder.jpg'}
                      alt={item.product_name}
                      className="w-24 h-24 object-cover rounded-xl"
                    />
                    <div className="flex-1">
                      <h4 className="text-xl font-bold text-gray-800">{item.product_name}</h4>
                      <p className="text-gray-600">بارکد: {item.barcode}</p>
                      {item.payment_type === 'installment' && (
                        <p className="text-purple-700 font-medium mt-2">
                          اقساطی — {item.months} ماهه — هر ماه { (item.gold_debt / item.months).toFixed(3) } گرم
                        </p>
                      )}
                    </div>
                    <p className="text-2xl font-bold text-gold-dark">
                      {Number(item.price).toLocaleString('fa-IR')} تومان
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* پیام نهایی */}
            <div className="bg-blue-50 rounded-2xl p-8 text-center">
              <p className="text-xl text-blue-900 font-bold mb-4">
                ممنون از خرید شما عزیز 💎
              </p>
              <p className="text-lg text-gray-700">
                فاکتور اقساطی شما آماده است. در هر سررسید، وزن طلا را به فروشگاه تحویل دهید.
              </p>
              <p className="text-lg text-gray-700 mt-4">
                برای مشاهده فاکتورها به <Link to="/profile/orders" className="text-gold-dark font-bold hover:underline">پنل کاربری → فاکتورها</Link> مراجعه کنید.
              </p>
            </div>
            <Link to={`/invoice/${order.id}`} className="bg-gold text-white py-4 px-10 rounded-xl text-xl font-bold">
  مشاهده فاکتور کامل
</Link>

            <div className="text-center mt-10">
              <Link to="/products" className="bg-gold hover:bg-gold-dark text-white font-bold py-5 px-12 rounded-2xl text-xl transition shadow-lg">
                ادامه خرید
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;